import { useState, useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import api from '../api';

// Hook che recupera il ruolo dell'utente loggato dal backend (/auth/check).
// Ritorna { ruolo, loading } dove ruolo è 'admin' | 'fornitore' | null.
export default function useRuolo() {
  const { isSignedIn, isLoaded } = useAuth();
  const [ruolo, setRuolo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let attivo = true;
    const carica = async () => {
      if (!isLoaded) return;
      if (!isSignedIn) {
        if (attivo) { setRuolo(null); setLoading(false); }
        return;
      }
      try {
        const res = await api.get('/auth/check');
        if (attivo) setRuolo(res.data?.utente?.ruolo || 'fornitore');
      } catch (_e) {
        if (attivo) setRuolo(null);
      } finally {
        if (attivo) setLoading(false);
      }
    };
    carica();
    return () => { attivo = false; };
  }, [isSignedIn, isLoaded]);

  return { ruolo, loading };
}
